// Theme's original Alpine.js code - DON'T TOUCH
if(typeof window.Maximize !== 'undefined' && window.Maximize.checkFileNotLoaded()) {
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xProductTabs", (firstBlockId, sectionId) => ({
        activeBlock: firstBlockId, 
        toggle: false, 
        label: '',
        init() {
          if (Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => {
              if (event.detail && event.detail.sectionId == sectionId) {
                this.activeBlock = event.detail.blockId;
                const currentBlock = document.querySelector(`.tabs__${event.detail.blockId}`);
                if (currentBlock) this.setTabActive(currentBlock);
              }
            })
          }
        },
        setTabActive(el) {
          this.label = el.dataset.tabTitle;
        }
      }));
    });
  });
}

// Custom VARIANT SWITCHING tabs - separate from theme's accordion tabs
(function() {
  console.log('Custom variant tabs script loaded');
  
  function initCustomVariantTabs() {
    console.log('Initializing custom variant tabs...');
    
    // ONLY target our custom tabs, not the theme's tabs
    const tabs = document.querySelectorAll('.custom-tab-button');
    
    if (tabs.length === 0) {
      console.log('No custom variant tab buttons found');
      return;
    }
    
    console.log('Found ' + tabs.length + ' custom variant tab buttons');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.dataset.tab;
        
        console.log('Custom tab clicked: ' + targetTab);
        
        // Remove active class from custom tabs only
        document.querySelectorAll('.custom-tab-button').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.custom-tab-content').forEach(c => c.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding content
        this.classList.add('active');
        const contentEl = document.getElementById(targetTab + '-content');
        if (contentEl) {
          contentEl.classList.add('active');
          console.log('Showed custom content: ' + targetTab + '-content');
        } else {
          console.error('Custom content element not found: ' + targetTab + '-content');
        }
      });
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomVariantTabs);
  } else {
    initCustomVariantTabs();
  }
  
  // Backup initialization
  setTimeout(initCustomVariantTabs, 500);
})();

